// extracted by mini-css-extract-plugin
module.exports = {"addCompanyWrp":"addToIdea_addCompanyWrp__3I9N9","modalTooltip":"addToIdea_modalTooltip__2BwUj","loaderWrp":"addToIdea_loaderWrp__1YKow"};